import { applyMiddleware, compose, createStore as createReduxStore } from "redux";
import createSagaMiddleware from "redux-saga";
import { createBrowserHistory } from "history";
import { connectRouter, routerMiddleware } from "connected-react-router";
import LogRocket from "logrocket";
import makeRootReducer from "./reducers";
import { rootSaga as onboardingSaga } from "../onboarding/sagas";

export const history = createBrowserHistory();

export const configureStore = (initialState = {}) => {
  // ======================================================
  // Middleware Configuration
  // ======================================================
  const sagaMiddleware = createSagaMiddleware();
  const middleware = [routerMiddleware(history), LogRocket.reduxMiddleware(), sagaMiddleware];

  // ======================================================
  // Store Enhancers
  // ======================================================
  const enhancers = [];
  let composeEnhancers = compose;

  if (process.env.NODE_ENV !== "production") {
    if (typeof window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ === "function") {
      composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    }
  }

  // ======================================================
  // Store Instantiation and HMR Setup
  // ======================================================

  const store = createReduxStore(
    connectRouter(history)(makeRootReducer()),
    initialState,
    composeEnhancers(applyMiddleware(...middleware), ...enhancers)
  );
  sagaMiddleware.run(onboardingSaga);
  store.asyncReducers = {};

  if (module.hot) {
    module.hot.accept("./reducers", () => {
      const reducers = require("./reducers").default;
      store.replaceReducer(reducers(store.asyncReducers));
    });
  }

  return store;
};
